import React, { useContext, useEffect, useState } from "react";
import { FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "./ProfileColPagesss.css";
import ProfileColPagesssContext from "../../../context/ProfileColPagesssContext";
import axiosInstance from "../../../api/axiosInstance";
import defaultPhoto from "../../../assest/user-default.png";
import { useTranslation } from "react-i18next";
/* ================= EXIF STRIP HELPER ================= */
const stripExifAndCompress = (file) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const reader = new FileReader();

    reader.onload = (e) => {
      img.src = e.target.result;
    };

    img.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      canvas.width = img.width;
      canvas.height = img.height;

      ctx.drawImage(img, 0, 0);

      canvas.toBlob(
        (blob) => {
          if (!blob) return reject("Image processing failed");

          const cleanFile = new File([blob], file.name, {
            type: "image/jpeg",
            lastModified: Date.now(),
          });

          resolve(cleanFile);
        },
        "image/jpeg",
        0.9
      );
    };

    img.onerror = reject;
    reader.onerror = reject;

    reader.readAsDataURL(file);
  });
};

const ProfileColPagesss = () => {
  const navigate = useNavigate();
  const { profilecolpagesssData, setProfilecolpagesssData } =
    useContext(ProfileColPagesssContext);

  const [collectorData, setCollectorData] = useState(null);
  const [photoPreview, setPhotoPreview] = useState(defaultPhoto);
  const { t } = useTranslation();
  const [uploading, setUploading] = useState(false);

  /* ================= LOAD INITIAL DATA ================= */
  useEffect(() => {
    if (profilecolpagesssData) {
      setCollectorData(profilecolpagesssData);
      setPhotoPreview(
        profilecolpagesssData.profilePicture || defaultPhoto
      );
    }
  }, [profilecolpagesssData]);

  if (!collectorData) {
    return <div className="profile-loading">{t("common.loading")}</div>;
  }

  /* ================= UPLOAD CLEAN IMAGE ================= */
  const uploadProfilePicture = async (file) => {
    try {
      setUploading(true);

      const formData = new FormData();
      formData.append("profilePicture", file);

      const { data } = await axiosInstance.post(
        "/admin/profile-picture",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (!data.success) {
       alert(data?.message || t("profile.uploadFailed"));
        return;
      }

      const updatedAdmin = {
        ...collectorData,
        profilePicture: data.data.admin.profilePicture,
      };

      setCollectorData(updatedAdmin);
      setProfilecolpagesssData(updatedAdmin);
      setPhotoPreview(updatedAdmin.profilePicture);
      localStorage.setItem("collectorProfile", JSON.stringify(updatedAdmin));

      alert(t("profile.uploadSuccess"));
    } catch (err) {
      console.error("UPLOAD ERROR:", err);
      alert("Upload failed. Check console logs.");
    } finally {
      setUploading(false);
    }
  };

  /* ================= HANDLE FILE INPUT ================= */
  const handlePhotoUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Instant preview
    setPhotoPreview(URL.createObjectURL(file));

    try {
      // 🔥 Remove EXIF metadata
      const cleanFile = await stripExifAndCompress(file);
      uploadProfilePicture(cleanFile);
    } catch (err) {
      console.error("IMAGE PROCESS ERROR:", err);
      alert("Failed to process image");
    }
  };

  /* ================= REMOVE PHOTO ================= */
  const handleRemovePhoto = async () => {
    try {
      const { data } = await axiosInstance.delete("/admin/profile-picture");

      if (data.success) {
        const updatedAdmin = {
          ...collectorData,
          profilePicture: defaultPhoto,
        };

        setCollectorData(updatedAdmin);
        setProfilecolpagesssData(updatedAdmin);
        setPhotoPreview(defaultPhoto);
        localStorage.setItem("collectorProfile", JSON.stringify(updatedAdmin));

      alert(t("profile.removeSuccess"));
      } else {
        alert(data?.message || t("profile.removeFailed"));
      }
    } catch (err) {
      console.error("REMOVE PHOTO ERROR:", err);
      alert(t("profile.removeFailed"));
    }
  };

  /* ================= SAVE PROFILE ================= */
  const handleSave = () => {
    setProfilecolpagesssData(collectorData);
    localStorage.setItem("collectorProfile", JSON.stringify(collectorData));
    alert(t("profile.saveSuccess"));
  };

  return (
    <div className="profilecolpagesss-main-container">
      <div className="profile-heading-wrapper">
        <FaArrowLeft className="back-arrow" onClick={() => navigate(-1)} />
        <h2 className="profilecolpagesss-heading">
  {t("profile.title")}
</h2>
      </div>

      <div className="profilecolpagesss-card">
        {/* LEFT */}
        <div className="profilecolpagesss-leftbox">
          <img
            src={photoPreview}
            className="profilecolpagesss-avatar"
            alt="profile"
          />

          <label className="profilecolpagesss-photo-btn">
          {uploading ? t("profile.uploading") : t("profile.updatePhoto")}
            <input type="file" hidden onChange={handlePhotoUpload} />
          </label>

          <button
            className="profilecolpagesss-remove-btn"
            onClick={handleRemovePhoto}
          >
           {t("profile.removePhoto")}
          </button>
        </div>

        {/* RIGHT */}
        <div className="profilecolpagesss-rightbox">
          <div className="profilecolpagesss-field">
           <label>{t("profile.name")}</label>
            <input
              type="text"
              value={collectorData.name}
              onChange={(e) =>
                setCollectorData({ ...collectorData, name: e.target.value })
              }
            />
          </div>

          <div className="profilecolpagesss-field">
          <label>{t("profile.email")}</label>
            <input type="text" value={collectorData.email} disabled />
          </div>

          <div className="profilecolpagesss-field">
           <label>{t("profile.department")}</label>
            <input
              type="text"
              value={collectorData.dept}
              onChange={(e) =>
                setCollectorData({ ...collectorData, dept: e.target.value })
              }
            />
          </div>

        <div className="profilecolpagesss-field">
  <label>{t("profile.phone")}</label>
  <input
    type="tel"
    inputMode="numeric"
    pattern="[0-9]*"
    maxLength={10} // change if needed
    value={collectorData.phone}
    onChange={(e) => {
      const onlyNumbers = e.target.value.replace(/\D/g, "");
      setCollectorData({
        ...collectorData,
        phone: onlyNumbers,
      });
    }}
  />
</div>


          <button className="profilecolpagesss-save-btn" onClick={handleSave}>
           {t("common.save")}
          </button>

          <button
            className="profilecolpagesss-change-password-btn"
            onClick={() => navigate("/passwordPagesss")}
          >
            {t("profile.changePassword")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProfileColPagesss;
